// The Demand Forecast guide (14_DemandForecastDashboard.jsx · ModuleHelp, Max 01/11).
const en = {
  refreshT: 'Refresh',
  refreshB: 'The first button reloads the source data; the second reloads the forecast with the filters you have set. Use them when the numbers look stale.',
  filtersT: 'Narrow the forecast',
  filtersB: 'Pick the horizon in weeks, then branch, channel, collection, category or SKU. Clear puts every filter back to its default.',
  statsT: 'The headline numbers',
  statsB: 'Forecast for the first week, for the next four weeks and in total, with the SKU count, plus WAPE, which tells you how far past forecasts were off.',
  tabsT: 'Three views',
  tabsB: 'Forecast shows the trend and breakdowns, SKU lists each SKU, and Backtest checks how past forecasts compared with what sold.',
  chartT: 'Actual against forecast',
  chartB: 'The grey line is what sold, the blue line the forecast, the orange line the candidate model, and the pale lines the upper and lower range. Hover to read a week.',
};
const ko = {
  refreshT: '새로고침',
  refreshB: '첫 번째 버튼은 원천 데이터를, 두 번째 버튼은 설정한 필터로 예측을 다시 불러옵니다. 숫자가 오래된 것 같을 때 사용하세요.',
  filtersT: '예측 범위 좁히기',
  filtersB: '예측 기간(주)을 고른 뒤 지점, 채널, 컬렉션, 카테고리, SKU를 선택합니다. 초기화는 모든 필터를 기본값으로 되돌립니다.',
  statsT: '핵심 숫자',
  statsB: '첫 주, 향후 4주, 전체 기간의 예측과 SKU 수, 그리고 과거 예측이 얼마나 빗나갔는지 보여주는 WAPE입니다.',
  tabsT: '세 가지 보기',
  tabsB: 'Forecast는 추이와 구분별 내역, SKU는 SKU별 목록, Backtest는 과거 예측과 실제 판매를 비교한 검증입니다.',
  chartT: '실적과 예측 비교',
  chartB: '회색 선은 실제 판매, 파란 선은 예측, 주황 선은 후보 모델, 옅은 선은 상한과 하한입니다. 마우스를 올리면 주별 값이 보입니다.',
};
const vi = {
  refreshT: 'Làm mới',
  refreshB: 'Nút đầu tải lại dữ liệu nguồn; nút thứ hai tải lại dự báo theo các bộ lọc bạn đã chọn. Dùng khi số liệu có vẻ cũ.',
  filtersT: 'Thu hẹp dự báo',
  filtersB: 'Chọn số tuần dự báo, rồi chi nhánh, kênh, bộ sưu tập, danh mục hoặc SKU. Nút xóa đưa mọi bộ lọc về mặc định.',
  statsT: 'Các con số chính',
  statsB: 'Dự báo tuần đầu, 4 tuần tới và toàn kỳ, kèm số SKU, cùng WAPE cho biết các dự báo trước đây lệch bao nhiêu.',
  tabsT: 'Ba chế độ xem',
  tabsB: 'Forecast cho xu hướng và các phần chia nhỏ, SKU liệt kê từng SKU, Backtest so dự báo cũ với số thực bán.',
  chartT: 'Thực tế so với dự báo',
  chartB: 'Đường xám là số đã bán, đường xanh là dự báo, đường cam là mô hình ứng viên, các đường nhạt là cận trên và cận dưới. Rê chuột để đọc từng tuần.',
};
const zh = {
  refreshT: '刷新',
  refreshB: '第一个按钮重新加载源数据；第二个按钮按你设置的筛选重新加载预测。数字看起来过时时使用。',
  filtersT: '缩小预测范围',
  filtersB: '先选预测周数，再选分店、渠道、系列、品类或 SKU。点击清除会把所有筛选恢复为默认值。',
  statsT: '关键数字',
  statsB: '第一周、未来四周和全部时段的预测，以及 SKU 数量，还有显示过去预测偏差程度的 WAPE。',
  tabsT: '三种视图',
  tabsB: 'Forecast 显示趋势和各维度明细，SKU 列出每个 SKU，Backtest 把过去的预测与实际销量对比。',
  chartT: '实际与预测对比',
  chartB: '灰线是实际销量，蓝线是预测，橙线是候选模型，浅色线是上下区间。把鼠标移上去可读取每周的值。',
};
const dictionary = { ns: 'tourDemand', en, ko, vi, zh };
export default dictionary;
